import HardwareSerializer from 'eflex/serializers/hardware';

export default class ZebraPrinterSerializer extends HardwareSerializer {}
